import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    addressExplanation: string;
    addressPlaceholder2: string;
    optIn: string;
    step: {
        docUpload: {
            uploadInfo: {
                employment: {
                    fullName: string;
                },
            }
        }
    }
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    verifyMyEmploymentStatus: 'VERIFY MY EMPLOYEE STATUS',
    cityPlaceholder: 'City',
    statePlaceholder: 'State',
    postalCodePlaceholder: 'ZIP Code',
    address: 'Mailing Address',
    addressPlaceholder: 'Street Address',
    addressExplanation: 'Personal address required',
    addressPlaceholder2: 'Street Address 2',
    infoShared1: 'Information entered here will be used for verification purposes and shared with Lovesac.',
    infoShared2: ' ',
    company: 'Organization',
    companyPlaceholder: 'Organization',
    firstName: 'First Name',
    firstNamePlaceholder: 'First Name',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Last Name',
    emailAddress: 'Email Address',
    emailAddressPlaceholder: 'Email Address',
    optIn: 'Yes, send me Lovesac marketing communications about exclusive sales, special offers, latest products and more.',
    step: {
        personalInfo: {
            title: 'Unlock this Special Employee-Only Offer for our Delivery Heroes',
        },
        docUpload: {
            title: 'We need some more info',
            submitButtonLabel: 'SUBMIT',
            cancelButtonLabel: 'CANCEL',
            uploadInstructions: 'Upload an official document that shows:',
            uploadInfo: {
                employment: {
                    fullName: 'Your full name',
                    company: 'Your company',
                    currentAffiliation: 'Your current affiliation with that company',
                },
            },
        },

        pending: {
            titleReview: 'Processing'
        },
        success: {
            title: 'Success! You\'ve been verified.',
            redirectUrl: 'https://www.lovesac.com/',
            redirectButtonText: 'USE CODE NOW',
            verificationOnly: `
                SheerID handles verification only.
                Now that you've been approved, please direct all questions about the
                promotion terms and/or code use to {companyName} customer service by email: customerlove@lovesac.com or by phone: 1-888-636-1223.
            `,
        },
    },
};
